// AUTO-GENERATED. DO NOT EDIT.
// Source: scripts/i18n/generate_i18n_catalogs.mjs

export const commonAudit = {
  createdBy: "作成者",
  createdAt: "作成日時",
  updatedBy: "更新者",
  updatedAt: "更新日時",
} as const;
